import requestApi  from '../services/requestApi';
import requestApiv2  from '../services/requestApiv2';
import requestClubv2  from '../services/requestClubv2';
// import requestI from "../services/requestI";

// const tempTime = new Date().getTime();

// 关注好友
export function get_user_friend_list(data) {
  return requestClubv2({
    url: `/index.php?c=user/user&m=get_user_friend_list`,
    method: 'post',
    data
  });
}

// 上传图片
// export function upload_attachment(data) {
//   return requestClubv2({
//     url: `/index.php?c=attachment/attachment&m=upload_attachment&fid=15&anonymous=0`,
//     method: 'post',
//     data
//   });
// }

// 发帖
export function send_thread_new(data) {
  return requestClubv2({
    url: `/index.php?c=thread/thread&m=send_thread_new`,
    method: 'post',
    data
  });
}

// 再次发帖
export function send_thread_old(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/thread', m: 'send_thread_old'},
  });
}


// 用户个人信息 old
export function get_user_info(data) {
  return requestClubv2({
    url: `/index.php?c=user/user&m=get_user_info`,
    method: 'post',
    data
  });
}

// // 用户个人信息 new
// export function get_user_info(data) {
//   return requestI({
//     url: `/index.php`,
//     method: "post",
//     data: { ...data, request_time: tempTime, c: "api/account", m: "user_info" },
//   });
// }

// 回帖
export function send_reply_new(data) {
  return requestClubv2({
    url: `/index.php?c=reply/reply&m=send_reply_new`,
    method: 'post',
    data
  });
}


// 回子评论
export function send_reply_replica(data) {
  return requestClubv2({
    url: `/index.php?c=reply/reply&m=send_reply_replica`,
    method: 'post',
    data
  });
}


// 帖子列表
export function get_thread_list(data) {
  return requestApi({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/thread', m: 'get_thread_list'},
  });
}

// 帖子详情
export function get_thread_info_by_tid(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/thread', m: 'get_thread_info_by_tid'},
  });
}

// 帖子回复列表
export function get_reply_list(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/reply', m: 'get_reply_list'},
  });
}

// 帖子引用回复的子评论
export function get_replica_reply_list(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/reply', m: 'get_replica_reply_list'},
  });
}

// 收藏帖子
export function add_favorite(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/favorite', m: 'add_favorite'},
  });
}
// 取消收藏帖子
export function del_favorite(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/favorite', m: 'del_favorite'},
  });
}

// 回复和帖子赞踩
export function reply_thumbs(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/reply', m: 'reply_thumbs'},
  });
}

// 帖子右侧用户信息
export function get_friend_info(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/friend', m: 'get_friend_info'},
  });
}

// // 他的好贴列表
// export function get_user_thread_list(data) {
//   return requestApiv2({
//     url: `/index.php`,
//     method: 'post',
//     data:{...data ,c: 'user/user', m: 'get_user_thread_list'},
//   });
// }



// 帖子/回复举报
export function do_report(data) {
  return requestClubv2({
    url: `/index.php?c=reply/report&m=do_report`,
    method: 'post',
    data
  });
}

// 删除回复
export function del_reply(data) {
  return requestClubv2({
    url: `/index.php?c=reply/reply&m=del_reply`,
    method: 'post',
    data
  });
}

// 删除帖子
export function del_thread(data) {
  return requestClubv2({
    url: `/index.php?c=thread/thread&m=del_thread`,
    method: 'post',
    data
  });
}


// // TF新帖
// export function get_thread_list_today(data) {
//   return requestApiv2({
//     url: `/index.php`,
//     method: 'post',
//     data:{...data ,c: 'topic/thread', m: 'get_thread_list_today'},
//   });
// }

// 是否登录
export function is_login(data) {
  return requestClubv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/auth', m: 'is_login'},
  });
}

// 关注好友
export function add_user_friend(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/friend', m: 'add_user_friend'},
  });
}
// 取消关注
export function del_user_friend(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/friend', m: 'del_user_friend'},
  });
}


// 拉黑用户
export function add_blacklist(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/user_extend', m: 'add_blacklist'},
  });
}
// 取消拉黑
export function del_blacklist(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/user_extend', m: 'del_blacklist'},
  });
}

// 打赏
export function do_feeding(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/reward', m: 'feeding'},
  });
}

// 点亮
export function do_light_up(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'user/reward', m: 'light_up'},
  });
}


// 抢红包
export function grab_red_pack_new(data) {
  return requestClubv2({
    url: `/index.php?c=thread/thread&m=grab_red_pack_new`,
    method: 'post',
    data
  });
}

// 红包领取详情
export function red_pack_info(data) {
  return requestClubv2({
    url: `/index.php?c=thread/thread&m=red_pack_info`,
    method: 'post',
    data
  });
}

// 打赏详情
export function reward_peach_record(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/thread', m: 'reward_peach_record'},
  });
}

// 用户首页私信消息
export function get_user_not_read_msg_num(data) {
  return requestClubv2({
    url: `/index.php?c=user/user&m=get_user_not_read_msg_num`,
    method: 'post',
    data
  });
}

// 红包状态
export function red_pack_status(data) {
  return requestApiv2({
    url: `/index.php`,
    method: 'post',
    data:{...data ,c: 'topic/thread', m: 'red_pack_status'},
  });
}